const throttled = {}

export default () => next => action => {
  const time = action.meta && action.meta.throttle
  const type = { action }

  if (!time) {
    return next(action)
  }

  if (throttled[type]) {
    return
  }

  throttled[type] = true
  setTimeout(() => { throttled[type] = false }, time)
  next(action)
}
